<template>
  <section class="tariff-table">
    <table>
      <tr>
        <th></th>
        <th start scope="col">
          <span class="padding header">{{
            $t('tarief.table_qwello_title')
          }}</span>
        </th>
      </tr>
      <tr>
        <th middle scope="row">
          <span class="padding header">{{ $t('tarief.table_kwh') }}</span>
        </th>
        <td>
          <span class="padding">{{ $t('tarief.table_1_kwh_qwello') }}</span>
        </td>
      </tr>
      <tr bottom>
        <th scope="row">
          <span class="padding header">{{
            $t('tarief.table_time_title')
          }}</span>
        </th>
        <td>
          <span class="padding">{{ $t('tarief.table_1_time_qwello') }}</span>
        </td>
      </tr>
    </table>
  </section>
</template>

<script>
export default {};
</script>

<style scoped>
.tariff-table {
  margin: 60px auto 100px auto;
  box-shadow: 0px 7px 20px #00000033;
  border-radius: 8px;
  padding: 16px 12px;
  width: max-content;
}
.tariff-title {
  margin-top: 60px;
  font: normal normal bold 14px/20px Lato;
  letter-spacing: 0px;
  position: relative;
  width: max-content;
  text-align: left;
  color: #2b4047;
}
.tariff-title::after {
  content: '';
  position: absolute;
  width: 100%;
  height: 4px;
  left: 0px;
  top: 100%;
  z-index: -1;
  background: #ffdf22;
}
.tariff-text {
  margin-top: 20px;
  font: normal normal normal 14px/20px Lato;
  letter-spacing: 0px;
  color: #2b4047;
}
.header {
  font-weight: bold;
  padding: 10px 50px 10px 0;
  display: inline-block;
}
.padding {
  font: normal normal normal 12px/18px Lato;
  letter-spacing: 0px;
  color: #2b4047;
}
.tr {
  padding: 200px;
}
tr[bottom] td {
  border-bottom: none;
  border-right: none;
}
tr td {
  border-right: none;
}
.empty {
  border-top: 2px solid white;
}
.bottom {
  margin-right: 1em;
}
th {
  font: normal normal bold 12px/18px Lato;
  letter-spacing: 0px;
  color: #2b4047;
}
th[scope='row'][middle] {
  border: 1px solid #a1b1b5;
}
th[scope='row'][middle] {
  border-left: 0;
}
th[scope='col'][start] {
  border-left: 1px solid #a1b1b5;
}
td {
  border: 1px solid #a1b1b5;
  border-collapse: collapse;
}
th,
td {
  padding: 5px;
  text-align: left;
}

@media (min-width: 1024px) {
  .tariff-table {
    box-shadow: 0px 7px 20px #00000033;
    border-radius: 8px;
    margin: 80px auto 100px auto;
    font-family: Lato;
    width: max-content;
    padding: 26px 36px;
    font-size: 20px;
  }
  .tariff-title {
    font: normal normal bold 20px/26px Lato;
    letter-spacing: 0.2px;
    font-size: 20px;
    margin-top: 80px;
    margin-bottom: 20px;
  }
  .tariff-title::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 5px;
    left: 0px;
    top: 100%;
    z-index: -1;
    background: #ffdf22;
  }
  .tariff-text {
    text-align: left;
    letter-spacing: 0.2px;
    color: #2b4047;
    font-size: 20px;
    font-weight: normal;
    font-family: Lato;
  }
  .padding {
    padding: 10px;
    display: block;
    font: normal normal normal 20px/26px Lato;
  }
  th {
    padding: 10px;
    color: #2b4047;
    letter-spacing: 0.2px;
    font-size: 20px;
  }
  .header {
    font: normal normal bold 20px/26px Lato !important;
    padding: 0 100px 0 0;
  }
}
</style>
